const uniqueIndexGenerator = (init = 0) => {
  let index = init;

  return () => {
    const value = index;
    index += 1;
    return value;
  };
};

export default uniqueIndexGenerator;
